<template>
  <a-card title="User information" size="small">
    <a-button
      slot="extra"
      icon="edit"
      type="link"
      @click="showUpdateDrawer"
      v-if="visibleUpdate"
    />
    <a-descriptions :column="1">
      <a-descriptions-item label="Username">
        {{ user.username }}
      </a-descriptions-item>
      <a-descriptions-item label="Fullname">
        {{ user.fullname }}
      </a-descriptions-item>
      <a-descriptions-item label="Email">
        {{ user.email }}
      </a-descriptions-item>
      <a-descriptions-item label="Phòng ban" v-if="user.department">
        <span v-if="user.department && user.department.status === 'DEACTIVE'">
          <del> {{ user.department.name }} </del>
        </span>
        <span v-else>
          {{ user.department.name }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Chức vụ" v-if="user.position">
        <span v-if="user.position && user.position.status === 'DEACTIVE'">
          <del> {{ user.position.name }} </del> </span
        ><span v-else>
          {{ user.position.name }}
        </span>
      </a-descriptions-item>

      <a-descriptions-item label="Quản lý trực tiếp">
        <a-button
          v-show="user.directManager"
          @click="goToEmployeeDetail(user.directManager.employeeId)"
          type="link"
        >
          {{
            user.directManager &&
            user.directManager.username &&
            user.directManager.fullname
          }}
        </a-button>
      </a-descriptions-item>
      <a-descriptions-item label="Admin chi nhánh">
        {{ user.adminOfLocation && user.adminOfLocation.name }}
      </a-descriptions-item>
      <a-descriptions-item label="Trạng thái">
        {{ user.status }}
      </a-descriptions-item>

      <a-descriptions-item label="Người tạo" v-if="user.author">
        {{ user.author && user.author.fullname }}
      </a-descriptions-item>
      <a-descriptions-item label="Ngày tạo">
        {{ user.createdAt | formatDateHour }}
      </a-descriptions-item>
      <a-descriptions-item label="Cập nhật lần cuối">
        {{ user.updatedAt | formatDateHour }}
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>

<script>
export default {
  props: {
    visibleUpdate: {
      type: Function,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showUpdateDrawer() {
      this.visibleUpdate(true);
    },

    /**
     * Go to view detail of Employee
     * @param employeeId {string} UUID of Employee what to go see detail
     */
    goToEmployeeDetail(employeeId) {
      if (
        employeeId &&
        typeof employeeId === "string" &&
        employeeId.trim().length > 0
      ) {
        this.$router.push(`/config/employee/${employeeId}/basic-info`);
      }
    },
  },
};
</script>
